import {NgModule} from '@angular/core';
import {CoreModule} from "../../core/core.module";
import {YE_ENTITY_PROVIDER} from "./ye.entity-provider";
import {YE_TEST_PROVIDERS} from "./test/ye-test-definition";


@NgModule({
  declarations: [
  ],
  exports:[
  ],
  imports: [
    CoreModule,
  ],
  providers: [YE_ENTITY_PROVIDER, YE_TEST_PROVIDERS]
})
export class YeModule { }
 
 
 
